var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-container full-height" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            visible: _vm.dialogMemberFormVisible,
            title: _vm.roleSettingObj.id
              ? "編輯" +
                _vm.roleSettingObj.account +
                "-" +
                _vm.roleSettingObj.name +
                "帳號"
              : "新增帳號",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogMemberFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("el-alert", {
                    attrs: {
                      closable: false,
                      title:
                        "密碼為使用不可逆的加密演算法，所以密碼無法查詢。只能設定新密碼。",
                      type: "warning",
                      effect: "dark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "memberForm",
                  attrs: {
                    rules: _vm.rules,
                    size: "mini",
                    model: _vm.roleSettingObj,
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "帳號", prop: "account" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.account,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "account", $$v)
                          },
                          expression: "roleSettingObj.account",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "name", $$v)
                          },
                          expression: "roleSettingObj.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Mail", prop: "mail" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.mail,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "mail", $$v)
                          },
                          expression: "roleSettingObj.mail",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "電話", prop: "mobile" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "mobile", $$v)
                          },
                          expression: "roleSettingObj.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "生日" } },
                    [
                      _vm.roleSettingObj.birthday
                        ? _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              placeholder: "請選擇領隊生日",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.roleSettingObj.birthday,
                              callback: function ($$v) {
                                _vm.$set(_vm.roleSettingObj, "birthday", $$v)
                              },
                              expression: "roleSettingObj.birthday",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "狀態" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.roleSettingObj.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.roleSettingObj, "status", $$v)
                            },
                            expression: "roleSettingObj.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("停用"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("啟用"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("黑名單"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "密碼", prop: "pwd" } },
                    [
                      _vm.roleSettingObj.id
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: {
                                type: _vm.showPwdInupt ? "primary" : "success",
                                size: "mini",
                              },
                              on: { click: _vm.showPwdInuptHandler },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.showPwdInupt ? "取消" : "更改密碼")
                              ),
                            ]
                          )
                        : _vm._e(),
                      !_vm.roleSettingObj.id || _vm.showPwdInupt
                        ? _c("el-input", {
                            attrs: { "show-password": "" },
                            model: {
                              value: _vm.roleSettingObj.pwd,
                              callback: function ($$v) {
                                _vm.$set(_vm.roleSettingObj, "pwd", $$v)
                              },
                              expression: "roleSettingObj.pwd",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "i",
                        {
                          staticStyle: {
                            color: "#ccc",
                            "font-size": "12px",
                            margin: "5px",
                          },
                        },
                        [
                          _vm._v(
                            "密碼原則：密碼必須包含英文，數字及長度介於6-16之間。"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div"),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("memberForm")
                    },
                  },
                },
                [_vm._v("確定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogMemberFormVisible = !_vm.dialogMemberFormVisible
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.rolesList.length > 0
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                visible: _vm.dialogFormVisible,
                title:
                  _vm.roleSettingObj.account +
                  "-" +
                  _vm.roleSettingObj.name +
                  "-" +
                  "角色設定",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible = $event
                },
              },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.rolesList,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "選取" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { label: scope.row.roleCode },
                                  model: {
                                    value: _vm.rolesSelected,
                                    callback: function ($$v) {
                                      _vm.rolesSelected = $$v
                                    },
                                    expression: "rolesSelected",
                                  },
                                },
                                [_vm._v(" 選取 ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2759007023
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "角色代碼" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" " + _vm._s(scope.row.roleCode) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      243896740
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "角色名稱" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" " + _vm._s(scope.row.roleName) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1840091566
                    ),
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveRoles },
                    },
                    [_vm._v("確定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogFormVisible = !_vm.dialogFormVisible
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            visible: _vm.dialogIntroFormVisible,
            title: _vm.roleSettingObj.id ? "編輯簡介" : "新增簡介",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogIntroFormVisible = $event
            },
            closed: _vm.onDialogClosed,
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("el-alert", {
                    attrs: {
                      closable: false,
                      title: "此為向外公開的個人簡介資料",
                      type: "warning",
                      effect: "dark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "introductionForm",
                  attrs: {
                    rules: _vm.introRules,
                    size: "mini",
                    model: _vm.roleSettingObj,
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "頭貼",
                        "label-width": _vm.formLabelWidth,
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("Upload", {
                            ref: "uploadRef",
                            attrs: {
                              accept: ".jpg,.jpeg,.png",
                              payload: _vm.roleSettingObj,
                              "limit-file-count": 1,
                              limitText:
                                "圖片尺寸:70x70，須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                              "data-obj": _vm.fileObj,
                              "use-drag": false,
                              action: "ToursCombine/saveIntroAvatar",
                              "auto-upload": false,
                              "show-file-list": true,
                              "form-on-loading-parent": _vm.listLoading,
                              "btn-txt": "上傳",
                              "before-file-list":
                                _vm.roleSettingObj.fileInfo &&
                                _vm.roleSettingObj.fileInfo.length
                                  ? _vm.roleSettingObj.fileInfo[0].files
                                  : [],
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名稱", prop: "authorName" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", "show-word-limit": "" },
                        model: {
                          value: _vm.roleSettingObj.authorName,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "authorName", $$v)
                          },
                          expression: "roleSettingObj.authorName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "簡介", prop: "introduction" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 4, maxRows: 4 },
                        },
                        model: {
                          value: _vm.roleSettingObj.introduction,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "introduction", $$v)
                          },
                          expression: "roleSettingObj.introduction",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "sort", $$v)
                          },
                          expression: "roleSettingObj.sort",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._l(
                    _vm.roleSettingObj.socialLinkList,
                    function (social, index) {
                      return _c(
                        "el-form-item",
                        {
                          key: index,
                          attrs: {
                            label: "社群" + (index + 1),
                            prop: "social." + index + ".id",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "請選擇" },
                              model: {
                                value: social.socialType,
                                callback: function ($$v) {
                                  _vm.$set(social, "socialType", $$v)
                                },
                                expression: "social.socialType",
                              },
                            },
                            _vm._l(_vm.socialLinkSelectList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                          _c("el-input", {
                            staticStyle: { width: "50%" },
                            model: {
                              value: social.url,
                              callback: function ($$v) {
                                _vm.$set(social, "url", $$v)
                              },
                              expression: "social.url",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeSocialLink(social)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ],
                        1
                      )
                    }
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", { on: { click: _vm.addSocialLink } }, [
                        _vm._v("新增社群"),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveIntroduction("introductionForm")
                    },
                  },
                },
                [_vm._v("確定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: { click: _vm.onDialogClosed },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "full-height",
          staticStyle: { padding: "20px", "padding-bottom": "0" },
        },
        [
          _c(
            "div",
            { staticStyle: { "padding-bottom": "0" } },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "搜尋" } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", placeholder: "輸入帳號或姓名" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleFilter($event)
                          },
                        },
                        model: {
                          value: _vm.listQuery.qry,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "qry", $$v)
                          },
                          expression: "listQuery.qry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(" 搜尋 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success", size: "mini" },
                          on: { click: _vm.addData },
                        },
                        [_vm._v("建立")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { position: "relative", height: "80%" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: _vm.tableKey,
                  attrs: {
                    size: "mini",
                    data: _vm.list,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "100%",
                  },
                  on: { "sort-change": _vm.sortChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "ID",
                      prop: "id",
                      sortable: "custom",
                      align: "center",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.id))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "帳號",
                      prop: "account",
                      sortable: "custom",
                      align: "left",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.account))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "姓名",
                      prop: "name",
                      sortable: "custom",
                      align: "center",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.name))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "mail",
                      prop: "mail",
                      align: "center",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.mail))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "角色",
                      prop: "roles",
                      sortable: "custom",
                      align: "center",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", [_vm._v(_vm._s(row.roles.toString()))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "狀態", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.status == 1
                                      ? "success"
                                      : "danger",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.status == 0
                                      ? "停用"
                                      : scope.row.status == 1
                                      ? "啟用"
                                      : "黑名單"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "email驗證",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.emailValidated == false
                              ? _c("i", {
                                  staticClass: "el-icon-circle-close",
                                  staticStyle: {
                                    "font-size": "28px",
                                    color: "red",
                                  },
                                })
                              : _c("i", {
                                  staticClass: "el-icon-circle-check",
                                  staticStyle: { "font-size": "28px" },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "資格審核", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _vm.checkLeaderRole(scope.row.roles)
                              ? [
                                  scope.row.manuallyValidated == false
                                    ? _c("i", {
                                        staticClass: "el-icon-circle-close",
                                        staticStyle: {
                                          "font-size": "28px",
                                          color: "red",
                                        },
                                      })
                                    : _c("i", {
                                        staticClass: "el-icon-circle-check",
                                        staticStyle: { "font-size": "28px" },
                                      }),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editData(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 編輯資料 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.title == "TC"
                    ? _c("el-table-column", {
                        attrs: { align: "center", label: "操作", width: "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        size: "mini",
                                        type: "warning",
                                        icon: "el-icon-key",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showSelfRoles(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 角色設定 ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2365833449
                        ),
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-edit",
                                  disabled: _vm.checkRole(scope.row.roles),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editIntroductionInfo(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 編輯簡介 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.checkPermission(["ITA-DEV"])
                    ? _c("el-table-column", {
                        attrs: { align: "center", label: "刪除", width: "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteMember(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 刪除 ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2994497502
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            staticStyle: { "padding-top": "0" },
            attrs: {
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.getList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }